import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SolarChartLinear from "../../icons/SolarChartLinear";
import SolarSettingsLinear from "../../icons/SolarSettingsLinear";
import SolarSiderbarLinear from "../../icons/SolarSiderbarLinear";
import SolarShieldUserLinear from "../../icons/SolarShieldUserLinear";
import SolarDocumentTextLinear from "../../icons/SolarDocumentTextLinear";
import SolarNotebookLinear from "../../icons/SolarNotebookLinear";
import SideBarItemList from "./SideBarItemList";
import env from "../../../utils/helpers/functions/env";
import MarketSideBarMenu from "../../../plugins/Market/components/MarketSideBarMenu";
import MobileSideBarMenu from "../../../plugins/Mobile/components/MobileSideBarMenu";
import { RedgerlabSideBarMenu } from "../../../plugins/loadRedgerlab";
import SolarUserLinear from "../../icons/SolarUserLinear.jsx";
import SolarRefreshLinear from "../../icons/SolarRefreshLinear";
import { useAuth } from "../../../context/AuthContext.jsx";
 
const SideBarUl = ({setMobSideBarShow}) => {

    const { t } = useTranslation();
    const { auth } = useAuth();
    const location = useLocation();

    return ( 
        <ul className="pc-navbar d-block"
            onClick={(e)=>{
                
                if (e?.target?.closest?.('.hide-sidebar'))
                    setMobSideBarShow(false);
            }}>
            <li className="pc-item pc-caption">
                <label>{t('SideBarUl.titleMainMenu')}</label>
            </li>
 
            <li className={`pc-item  ${location.pathname == '/dashboard' ? 'active' : ''}`} >
                <Link className="pc-link hide-sidebar"
                    to="/dashboard">
                    <span className="pc-micon">
                        
                        <SolarChartLinear/> 
                    </span>
                    <span className="pc-mtext">{t('SideBarUl.itemDashboard')}</span>
                </Link>
            </li>

            {(auth?.user?.admin != 0) && (
                <SideBarItemList
                    title={t('SideBarUl.itemAdministration')}
                    icon={(<SolarShieldUserLinear/>)}
                    itemsList={[
                        {label:t('SideBarUl.itemUsers'), to:'/users', startsWith:'/users', icon:(<SolarUserLinear/>)},
                        {label:t('SideBarUl.itemRedirects'), to:'/redirects', startsWith:'/redirects', icon:(<SolarRefreshLinear/>)},
                        {label:t('SideBarUl.itemSettings'), to:'/settings', startsWith:'/settings', icon:(<SolarSettingsLinear/>)}
                    ]}/>
            )}
  
            <SideBarItemList
                title={t('SideBarUl.itemContent')} 
                icon={(<SolarSiderbarLinear/>)}
                itemsList={[
                    {label:t('SideBarUl.itemPages'), to:'/pages', startsWith:'/pages', icon:(<SolarDocumentTextLinear/>)},
                    {label:t('SideBarUl.itemBlog'), to:'/blog', startsWith:'/blog', icon:(<SolarNotebookLinear/>)} 
                ]}/>

            
            {(env('REACT_APP_PLUGINS')==1) && (
            <li className="pc-item pc-caption">
                <label>{t('SideBarUl.titlePlugins')}</label>
            </li>)} 
 
            {(env('REACT_APP_MARKET')==1) && (<MarketSideBarMenu/>)}
            {(env('REACT_APP_MOBILE')==1) && (<MobileSideBarMenu/>)}
            {RedgerlabSideBarMenu && env('REACT_APP_REDGERLAB') == 1 && (<RedgerlabSideBarMenu/>)}

        </ul>
    )
}

export default SideBarUl;